import Link from "next/link";

interface PLinkProps {
  children?: React.ReactNode;
  link: { as?: string; href: string };
  keyString?: string;
  replace?: boolean;
  passHref?: boolean;
  shallow?: boolean;
  onClick?: (e: any) => void;
}

export const PLink: React.FC<PLinkProps> = ({
  children,
  link,
  replace,
  passHref,
  keyString,
  shallow,
  onClick,
}) => {
  return (
    <Link
      href={link.href}
      as={link.as}
      replace={replace}
      passHref={passHref}
      key={keyString}
      shallow={shallow}
      // Phase 0: keep the exact Next 12 DOM. Without legacyBehavior, Next
      // 13+ Link renders its own <a> around the span, which (a) nests <a>
      // inside consumers' own anchors — invalid HTML — and (b) inserts an
      // extra element that breaks selectors written against
      // `.parent > span > …` and flex/width chains (sign-in banner flex row,
      // PayScreen Go-to-Menu width, …). legacyBehavior is removed in Next 16
      // — the forward fix is PLink rendering the anchor itself and consumers
      // dropping their inner <a>s (Phase 1).
      legacyBehavior
    >
      <span onClick={onClick}>{children}</span>
    </Link>
  );
};
